<template>
    <!-- 账号登录/注册 -->
    <div class="login-content df fdc">
        <div class="f1">
            <div class="title df">
                <span class="active">账号登录</span>
            </div>
            <!-- 单选框手机号或者邮箱 -->
            <div class="phone-email mt-40">
                <el-radio-group v-model="propformdata.phoneEmail" @change="handlePhoneEmailChange">
                    <el-radio label="phone">手机号</el-radio>
                    <el-radio label="email">邮箱</el-radio>
                </el-radio-group>
            </div>

            <el-form ref="form" :model="propformdata" :rules="rules">
                <el-form-item prop="phone" v-if="propformdata.phoneEmail == 'phone'">
                    <!-- 手机号输入框 前面加上区号 -->
                <div class="phone-input df">
                    <div class="phone-input-item">
                        <el-select v-model="propformdata.phoneCode" placeholder="" style="width: auto">
                            <el-option :label="'+ ' + 86" value="86"></el-option>
                        </el-select>
                    </div>
                    <el-input v-model="propformdata.phone" class="phone-input-item ml-8" placeholder="请输入手机号" />
                </div>
                </el-form-item>
                

                <!-- 邮箱 -->
                <el-form-item prop="email" v-else>
                    <div class="phone-input">
                        <el-input v-model="propformdata.email" class="phone-input-item" placeholder="请输入邮箱" />
                    </div>
                </el-form-item>

                <el-form-item prop="code">
                    <!-- 验证码输入框 -->
                <div class="code-input df">
                    <el-input v-model="propformdata.code" placeholder="请输入验证码" />
                    <el-button @click="handleGetCode" :disabled="showCodeTime" :class="{ disabled: showCodeTime }">{{
                        showCodeTime ? "重新发送 (" + codeTime + ")" : "获取验证码"
                        }}</el-button>
                </div>
                </el-form-item>
            </el-form>

            <!-- 密码登录提示 -->
            <div class="password-login">
                <el-button type="text" @click="handlePasswordLogin(2)">密码登录</el-button>
            </div>
        </div>
        <!-- 登录按钮 -->
        <div class="login-button">
            <el-button type="primary" @click="handleLogin">登录/注册</el-button>
            <div class="mt-24 verify-box">
                <!-- 把这个多选变成圆形样式 -->
                <el-checkbox v-model="propformdata.privacy" class="checkbox-circle">我已阅读并同意</el-checkbox><span
                    @click="handleDialogVisible"> 隐私声明 </span> 与
                <span> 用户注册协议</span>
            </div>
        </div>

        <!-- 弹框协议 -->
        <el-dialog :title="dialogTitle" :append-to-body="true" :z-index="2000" :visible.sync="dialogVisible">
            <div class="dialog-content">
                <div class="dialog-content-item" v-html="dialogContent"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
var this_ = this;
export default {
    data() {
        return {
            // 弹框协议
            dialogVisible: false, // 是否显示弹框
            dialogTitle: "", // 弹框标题
            dialogContent: "", // 弹框内容

            // 账号登录/注册
            propformdata: {
                phoneEmail: "phone", //选择手机还是邮箱
                phoneCode: "86", //手机区号
                phone: "", //手机号
                email: "", //邮箱
                code: "", //验证码
                privacy: true, //隐私声明
            },
            rules: {
                phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
                email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
                code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
            },

            // 验证码倒计时
            codeTime: 60, //验证码倒计时
            showCodeTime: false, // 是否显示倒计时
            timer: null, // 定时器
        };
    },
    // 接收参数 formdata
    props: {
        formdata: {
            type: Object,
            default: () => {
                return {
                    phoneEmail: "phone",
                    phoneCode: "86",
                };
            },
        },
    },
    // 监听参数 formdata
    watch: {
        formdata: {
          handler(newVal) {
            this.propformdata = newVal;
          },
          immediate: true,
          deep: true
        },
    },
    methods: {
        // 弹框协议
        handleDialogVisible() {
            this.dialogVisible = true;
            this.dialogTitle = "隐私声明";
            this.dialogContent = "隐私声明";
        },

        // 密码登录
        handlePasswordLogin(type) {
            this.$emit("handlePasswordLogin", type);
        },

        // 登录
        handleLogin() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    alert(this.propformdata.privacy)
                    if(this.propformdata.privacy){
                        this.$emit("handleLogin", this.propformdata);
                    }else{
                        this.$message.error("请阅读并同意隐私声明和用户注册协议");
                    }
                }
            });
        },
        // 获取验证码
        handleGetCode() {
            // 验证手机号
            if (this.propformdata.phoneEmail == "phone") {
                // 验证手机号是否为空
                if (!this.propformdata.phone) {
                    this.$message.error("请输入手机号");
                    return;
                }
                // 验证手机号格式
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (!phoneRegex.test(this.propformdata.phone)) {
                    this.$message.error("请输入正确的手机号");
                    return;
                }
            }
            // 验证邮箱
            if (this.propformdata.phoneEmail == "email") {
                // 验证邮箱是否为空
                if (!this.propformdata.email) {
                    this.$message.error("请输入邮箱");
                    return;
                }
                // 验证邮箱格式
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.propformdata.email)) {
                    this.$message.error("请输入正确的邮箱");
                    return;
                }
            }

            // 倒计时
            let time = 60;
            this.showCodeTime = true;
            this.timer = setInterval(() => {
                time--;
                this.codeTime = time;
                if (time <= 0) {
                    clearInterval(this_.timer);
                    this_.showCodeTime = false;
                }
            }, 1000);
        },
        // 手机号或者邮箱切换
        handlePhoneEmailChange(val) {
            this.codeTime = 60;
            this.showCodeTime = false;
            clearInterval(this.timer);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep(){
    .el-form-item{
        margin-bottom: 0;
    }
}
.verify-box {
    font-size: 12px;
    line-height: 22px;
    color: #aeaeae;

    span {
        color: #b7251e;
        cursor: pointer;
    }
}

.checkbox-circle {
    ::v-deep() {
        .el-checkbox__inner {
            width: 19px;
            height: 19px;
            border-radius: 50%;
        }

        .el-checkbox__inner::after {
            width: 4px;
            left: 6px;
            top: 3px;
        }

        .el-checkbox__label {
            font-size: 12px;
            line-height: 22px;
            color: #aeaeae;
            padding-left: 6px;
        }
    }
}

* {
    font-family: "harmonyos";
    font-weight: 400;
}

::v-deep() {
    .el-radio__inner {
        width: 20px;
        height: 20px;
        border: 2px solid rgb(183, 37, 30) !important;
    }
}

.login-button {
    .el-button--primary {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        padding: 0;
        background: rgb(183, 37, 30);
        color: rgb(255, 255, 255);
        font-size: 16px;
    }
}

.phone-input {
    .phone-input-item {
        height: 60px;
        border-radius: 8px;
        background: rgb(245, 248, 255);
        padding: 10px 16px;
        margin-top: 24px;

        ::v-deep() {
            .el-input--suffix .el-input__inner {
                border: none;
                background: transparent;
                padding-right: 0;

                color: rgb(179, 179, 179);

                font-size: 14px;
            }

            .el-input__inner {
                padding: 0;
                border: none;
                background: transparent;

                &::placeholder {
                    color: rgb(179, 179, 179);
                    font-size: 14px;
                }
            }

            .el-input__suffix {
                display: none;
            }
        }
    }
}

.password-login {
    margin-top: 24px;

    ::v-deep() {
        .el-button {
            color: rgb(183, 37, 30);
            font-size: 16px;
            margin-top: 24px;
            padding: 0;
            margin: 0;
        }
    }
}

.code-input {
    width: 400px;
    height: 60px;
    padding: 10px 16px 10px 16px;
    border-radius: 4px;
    background: rgb(245, 248, 255);
    margin-top: 24px;

    ::v-deep() {
        .el-button.disabled {
            color: #b3b3b3;
        }

        .el-input__inner {
            border: none;
            background: transparent;
            padding: 0;

            &::placeholder {
                color: rgb(179, 179, 179);
                font-size: 14px;
            }
        }

        .el-button {
            border: none;
            background: transparent;
            padding: 0;
            margin: 0;
            color: rgb(183, 37, 30);
            font-size: 14px;
        }
    }
}

.login-container {
    width: 100%;
    height: 100%;
    position: relative;

    .login-content {
        width: 520px;
        height: 600px;
        min-height: 500px;
        max-height: 100vh;
        border-radius: 16px;
        box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
        background: rgb(255, 255, 255);
        padding: 80px 60px;
        position: absolute;
        right: 120px;
        top: 50%;
        transform: translateY(-50%);
    }

    .title {
        font-size: 20px;
        line-height: 30px;
        color: rgb(25, 25, 25);

        span {
            font-size: 20px;
            line-height: 30px;
            cursor: pointer;
            position: relative;
        }

        span.active::after {
            content: "";
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #b7251e;
            position: absolute;
            bottom: 0;
            left: 0;
        }
    }
}
</style>